export const getFromStorage = (item) => sessionStorage.getItem(`FFF_${item}`);

export const getJsonFromStorage = (item) => {
  try {
    return JSON.parse(getFromStorage(item));
  } catch (error) {
    // eslint-disable-next-line no-console
    console.error('Error when deserializing JSON');
  }
  return null;
};

export const setToStorage = (item, value) => sessionStorage.setItem(`FFF_${item}`, value);

export const setJsonToStorage = (item, value) => {
  try {
    sessionStorage.setItem(`FFF_${item}`, JSON.stringify(value));
  } catch (error) {
    // eslint-disable-next-line no-console
    console.error('Error when serializing JSON');
  }
  return null;
};

export const removeFromStorage = (key) => sessionStorage.removeItem(`FFF_${key}`);
